import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";

import { IMAGE_BASE_URL, SizeVerification } from "../../constants/constants";
import styles from "../../scss/common/ProductCard.module.scss";
import { InputField } from "../theme/Input";
import { SelectField } from "../theme/select";
import { useParams } from "react-router-dom";
import { Decrypt, imageOnError } from "../utils/Functions";
import { Box } from "@mui/system";
import AppContainer from "../theme/Container";
import AppButton from "../theme/Button";

interface IProps {
  item: any;
  itemId: string;
  i: number;
  length: number;
  setCheckAll: (value: boolean) => void;
  openId: any;
  setOpenId: (value: any) => void;
  saveProduct: (
    productId: string,
    options: string,
    value: any,
    price?: number,
    save?: boolean
  ) => void;
  saveOptopnList: any;
  saveProductChange: boolean;
  setSaveProductChange: (value: boolean) => void;
  selectedValueName?: { productId: string | number, optionsId: string | number, value: string }[];
  setSelectedValueName?: (value: { productId: string | number, optionsId: string | number, value: string }[]) => void;
  isOpenSizeConfirmation: boolean;
  setIsOpenSizeConfirmation: (value: boolean) => void;
  selectedItem: any;
  setSelectedItem: (value: any) => void;
}
const BundleDetailCards = ({
  item,
  itemId,
  i,
  length,
  setCheckAll,
  openId,
  setOpenId,
  saveProduct,
  saveOptopnList,
  saveProductChange,
  setSaveProductChange,
  selectedValueName,
  setSelectedValueName,
  isOpenSizeConfirmation,
  setIsOpenSizeConfirmation,
  selectedItem,
  setSelectedItem,
}: IProps) => {
  const params = useParams();
  // const [age, setAge] = React.useState("");
  const [check, setCheck] = useState(false);
  const [error, setError] = useState("");
  const [expanded, setExpanded] = useState(false);
  // const [firstOpen, setFirstOpen] = useState(false);
  const [checkSave, setCheckSave] = useState(false);
  const [qty, setQty] = useState("1");
  const [selectId, setSelectedId] = useState<any>(null);
  const [productCartQty, setProductCartQty] = useState(0);


  // const handleChange = (event: SelectChangeEvent) => {
  //   setAge(event.target.value as string);
  // };
  const cartDataInfoD = localStorage?.getItem("cart");
  const cartDataInfo = Decrypt(cartDataInfoD);
  const cartAllData = cartDataInfo ? JSON.parse(cartDataInfo) : [];

  useEffect(() => {
    if (item.minimum_quantity && item.minimum_quantity !== null) {
      setQty(item.minimum_quantity);
      saveProduct(itemId, "quantity", item.minimum_quantity, item.club_price);
    } else {
      setQty("1");
      saveProduct(itemId, "quantity", 1, item.club_price);
    }
  }, [item]);

  useEffect(() => {
    if (i === openId) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [i, openId]);
  const handleSave = (productId: any) => {
    setSelectedItem({
      itemId, item, i, itemLength: length, club_price: item.club_price
    });
    const isExist = selectedValueName?.filter((item: any) => item.productId === productId && SizeVerification.includes(item.value.toLowerCase()));
    if (isExist && isExist.length > 0) {
      setIsOpenSizeConfirmation(true);
    } else {
      save({
        itemId, item, i, itemLength: length,
        club_price: item.club_price
      })
    }
  }

  const save = (itemDetail: any) => {
    setCheckSave(true);

    const data = saveOptopnList.filter((product: any) => {
      return product.value == "" && product.productId == itemDetail.itemId;
    });

    if (data.length > 0) {
      setCheck(false);
    } else {
      saveProduct(itemDetail.itemId, "quantity", qty, itemDetail.club_price, true);
      setCheck(true);
      // setFirstOpen(false);
      setOpenId(itemDetail.i + 1);

      setSaveProductChange(!saveProductChange);
      setIsOpenSizeConfirmation(false);
      setSelectedItem(null);
    }
    if (itemDetail.i === itemDetail.itemLength - 1) {
      setCheckAll(true);
    } else {
      setCheckAll(false);
    }
  };

  const changeQty = (newQty: any) => {
    setQty(parseInt(newQty).toString());
    const mimQty =
      item && item.minimum_quantity && item.minimum_quantity !== null
        ? item.minimum_quantity
        : 1;
    if (newQty === "") {
      setError("Minimum Quantity allowed is " + mimQty);
    } else if ((newQty || newQty === 0) && newQty < parseInt(mimQty)) {
      setError("Minimum Quantity allowed is " + mimQty);
    } else if (
      item &&
      item.maximum_quantity &&
      item.maximum_quantity !== null &&
      (newQty || newQty === 0) &&
      newQty > Number(item.maximum_quantity) - Number(productCartQty)
    ) {
      setError("Maximum Quantity allowed is " + item.maximum_quantity);
    } else {
      setError("");

      saveProduct(itemId, "quantity", parseInt(newQty), item.club_price);
    }
  };

  const handleOnChangeSize = (itemId: string, optionsId: string, value: string) => {
    if (selectedValueName && setSelectedValueName) {
      const selectedValueNameCopy = selectedValueName;
      const selectedValue = selectedValueNameCopy.findIndex(
        (product: any) => product.optionsId === optionsId && product.productId === itemId
      );
      if (selectedValue !== -1) {
        selectedValueNameCopy[selectedValue].value = value;
      } else {
        selectedValueNameCopy.push({ productId: itemId, optionsId: optionsId, value: value });
      }
      setSelectedValueName(selectedValueNameCopy);
    }
  };
  useEffect(() => {
    const cartItems = cartAllData.find(
      (item: any) => item.id == params.id && !item.isSingleProduct
    );

    if (cartItems) {
      const bundleProducts = cartItems.bundle_products;
      const cartBundleProducts = bundleProducts.filter(
        (item: any) => item.id == itemId
      );
      let totalQty = 0;
      cartBundleProducts.map((item: any) => {
        totalQty += Number(item.store_product_detail.quantity);
      });

      setProductCartQty(totalQty);
    }
  }, [cartAllData]);

  return (
    <>
      <AppContainer>
        <div className={styles.bundleDetail}>
          <div className={styles.bundleDetail}>
            <Accordion
              onChange={() => {
                setExpanded(!expanded);
                setOpenId(i);
              }}
              expanded={expanded}
              className={`containerAccordion ${styles.acoContainer}`}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className={styles.bundleDetail_heading}>
                  {check && !expanded ? (
                    <label className={styles.bundleDetail_checkbox}>
                      <input type="checkbox" checked />
                      <span className={styles.bundleDetail_checkmark}></span>
                    </label>
                  ) : null}
                  {!expanded && (
                    <div className={styles.imgWrap}>
                      <img
                        loading="lazy"
                        onError={imageOnError}
                        src={
                          item.store_product_images[0]
                            ? IMAGE_BASE_URL + item.store_product_images[0].image
                            : "/images/prodPlaceholder.png"
                        }
                        alt=""
                      />
                    </div>
                  )}

                  <Typography className={styles.accordionTitle}>
                    {item.product_name}
                  </Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className={styles.detailWrap}>
                  <div className={styles.imgWrap}>
                    <img
                      loading="lazy"
                      onError={imageOnError}
                      src={
                        item.store_product_images[0]
                          ? IMAGE_BASE_URL + item.store_product_images[0].image
                          : "/images/prodPlaceholder.png"
                      }
                      alt=""
                    />
                  </div>
                  <div className={styles.contentWrap}>
                    <Grid container spacing={2}>
                      {/* <Grid item xs={12}>
                      <p className={styles.cartQty}>
                        {productCartQty !== 0
                          ? `Currently in your cart - ${productCartQty}`
                          : ""}
                      </p>
                    </Grid> */}

                      <Grid item xs={6}>
                        <div className={styles.bundle_custom_filed}>
                          <Box component="form" noValidate autoComplete="off">
                            <InputField
                              name="quantity"
                              valueData={qty}
                              isNotFormik={true}
                              type="number"
                              label="Quantity"
                              placeholder="Enter quantity"
                              onChangeWork={(items) => {
                                changeQty(items?.target?.value ?? 1);
                              }}
                              inputProps={{
                                max:
                                  Number(item.maximum_quantity) -
                                  Number(productCartQty),
                                min: parseInt(item.minimum_quantity),
                              }}
                            />
                            <div className={styles.loseHigh}>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (Number(qty) > 1) {
                                    changeQty(Number(qty) - 1);
                                  }
                                }}
                                className={styles.lose}
                              >
                                -
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  const qtyCopy = qty === "NaN" ? 0 : qty;
                                  changeQty(Number(qtyCopy) + 1);
                                }}
                                className={styles.High}
                              >
                                +
                              </button>
                            </div>
                          </Box>
                          <span className={styles.error}>{error}</span>
                          <p className={styles.cartQty}>
                            {item &&
                              item.minimum_quantity &&
                              item.minimum_quantity !== null
                              ? `${item.minimum_quantity} minimum `
                              : ""}{" "}
                            {item &&
                              item.maximum_quantity &&
                              item.maximum_quantity !== null
                              ? ` - ${item.maximum_quantity} maximum`
                              : ""}
                          </p>
                        </div>
                      </Grid>
                      {item.store_options
                        ? item.store_options.map(
                          (optionsData: any, index: number) => {
                            const storeProductOptions = item.store_product_options.find((innerItem: any) => innerItem.store_option_id === optionsData.store_option_id);
                            const display_name =
                              storeProductOptions?.display_name ??
                              optionsData.display_name;
                            if (optionsData.option_type === 1) {
                              if (optionsData.input_type === 1) {
                                const selectOption: {
                                  title: any;
                                  value: any;
                                }[] = [];
                                optionsData.store_option_items.map(
                                  (option: any) => {
                                    selectOption.push({
                                      title: option.option_name,
                                      value: option.id,
                                    });
                                  }
                                );

                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id &&
                                    product.productId === itemId
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }

                                return (
                                  <Grid item xs={6} key={index}>
                                    <SelectField
                                      label={display_name}
                                      // label="Size"
                                      value={selectedValue}
                                      name=""
                                      placeholder="Select Size"
                                      options={selectOption}
                                      selectedValue={(items) => {
                                        handleOnChangeSize(itemId,
                                          optionsData.id,
                                          items.title);
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please select size
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 2) {
                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id &&
                                    product.productId === itemId
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <InputField
                                      isNotFormik={true}
                                      name=""
                                      label={display_name}
                                      placeholder={`Enter ${display_name}`}
                                      valueData={selectedValue}
                                      onChangeWork={(item) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          item.target.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please enter {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 3) {
                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id &&
                                    product.productId === itemId
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <InputField
                                      name=""
                                      isNotFormik={true}
                                      label={display_name}
                                      placeholder={`Enter ${display_name}`}
                                      valueData={selectedValue}
                                      onChangeWork={(items) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.target.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please enter {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 4) {
                                const data = saveOptopnList.filter(
                                  (product: any) => {
                                    return product.optionsId === optionsData.id;
                                  }
                                );

                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }

                                return (
                                  <Grid item xs={6}>
                                    <FormControl>
                                      <FormLabel
                                        className="form_label"
                                        id="demo-row-radio-buttons-group-label"
                                      >
                                        {display_name}
                                        {/* Size */}
                                      </FormLabel>
                                      <RadioGroup
                                        onChange={(items) => {
                                          saveProduct(
                                            itemId,
                                            optionsData.id,
                                            items.target.value
                                          );
                                        }}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                      >
                                        <FormControlLabel
                                          value="Yes"
                                          control={<Radio />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value="No"
                                          control={<Radio />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please select{" "}
                                        <span
                                          style={{
                                            textTransform: "lowercase",
                                            color: "red",
                                          }}
                                        >
                                          size
                                        </span>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              }
                            } else if (optionsData.option_type === 2) {
                              if (optionsData.input_type === 1) {
                                const selectOption: {
                                  title: any;
                                  value: any;
                                }[] = [];
                                optionsData.store_option_items.map(
                                  (option: any) => {
                                    selectOption.push({
                                      title: option.option_name,
                                      value: option.id,
                                    });
                                  }
                                );
                                const data = saveOptopnList.filter(
                                  (product: any) => {
                                    return (
                                      product.value === selectId &&
                                      product.optionsId === optionsData.id
                                    );
                                  }
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <SelectField
                                      label={display_name}
                                      // label="Color"
                                      name=""
                                      value={selectedValue}
                                      placeholder={`Select ${optionsData.option_type === 2
                                        ? "Color"
                                        : display_name
                                        }`}
                                      options={selectOption}
                                      selectedValue={(items) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.value
                                        );
                                        setSelectedId(items?.value);
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please select{" "}
                                        {optionsData.option_type === 2
                                          ? "color"
                                          : display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 2) {
                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id &&
                                    product.productId === itemId
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <InputField
                                      name=""
                                      isNotFormik={true}
                                      label={display_name}
                                      placeholder={`Enter ${display_name}`}
                                      valueData={selectedValue}
                                      onChangeWork={(items) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.target.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please enter {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 3) {
                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id &&
                                    product.productId === itemId
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <InputField
                                      name=""
                                      isNotFormik={true}
                                      label={display_name}
                                      placeholder={`Enter ${display_name}`}
                                      valueData={selectedValue}
                                      onChangeWork={(items) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.target.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please enter {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 4) {
                                const data = saveOptopnList.filter(
                                  (product: any) => {
                                    return product.optionsId === optionsData.id;
                                  }
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <FormControl>
                                      <FormLabel
                                        className="form_label"
                                        id="demo-row-radio-buttons-group-label"
                                      >
                                        {display_name}
                                        {/* Color */}
                                      </FormLabel>
                                      <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(items) => {
                                          saveProduct(
                                            itemId,
                                            optionsData.id,
                                            items.target.value
                                          );
                                        }}
                                      >
                                        <FormControlLabel
                                          value="Yes"
                                          control={<Radio />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value="No"
                                          control={<Radio />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                    {check && selectedValue === "" ? (
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                          marginTop: "5px",
                                          display: "block",
                                          left: "1px",
                                        }}
                                      >
                                        Please select {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              }
                            } else if (optionsData.option_type === 3) {
                              if (optionsData.input_type === 1) {
                                const selectOption: {
                                  title: any;
                                  value: any;
                                }[] = [];
                                optionsData.store_option_items.map(
                                  (option: any) => {
                                    selectOption.push({
                                      title: option.option_name,
                                      value: option.id,
                                    });
                                  }
                                );

                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id &&
                                    product.productId === itemId
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <SelectField
                                      label={display_name}
                                      name=""
                                      value={selectedValue}
                                      placeholder={`Select ${display_name}`}
                                      options={selectOption}
                                      selectedValue={(items) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please select {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 2) {
                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id &&
                                    product.productId === itemId
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <InputField
                                      name=""
                                      isNotFormik={true}
                                      label={display_name}
                                      placeholder={`Enter ${display_name}`}
                                      valueData={selectedValue}
                                      onChangeWork={(items) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.target.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please enter {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 3) {
                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }
                                return (
                                  <Grid item xs={6} key={index}>
                                    <InputField
                                      isNotFormik={true}
                                      name=""
                                      label={display_name}
                                      placeholder={`Enter ${display_name}`}
                                      valueData={selectedValue}
                                      onChangeWork={(items) => {
                                        saveProduct(
                                          itemId,
                                          optionsData.id,
                                          items.target.value
                                        );
                                      }}
                                    />
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please enter {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              } else if (optionsData.input_type === 4) {
                                const data = saveOptopnList.filter(
                                  (product: any) =>
                                    product.optionsId === optionsData.id
                                );
                                let selectedValue = "";
                                if (data.length > 0) {
                                  selectedValue = data[0].value;
                                }

                                return (
                                  <Grid item xs={6} key={index}>
                                    <FormControl>
                                      <FormLabel
                                        className="form_label"
                                        id="demo-row-radio-buttons-group-label"
                                      >
                                        {display_name}
                                      </FormLabel>
                                      <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(items) => {
                                          saveProduct(
                                            itemId,
                                            optionsData.id,
                                            items.target.value
                                          );
                                        }}
                                      >
                                        <FormControlLabel
                                          value="Yes"
                                          control={<Radio />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value="No"
                                          control={<Radio />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                    {checkSave && selectedValue === "" ? (
                                      <span className={styles.error}>
                                        Please select {display_name}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                );
                              }
                            }
                          }
                        )
                        : "1"}
                    </Grid>
                    {item?.description.replace(/(<([^>]+)>)/gi, "").trim() !==
                      "" ? (
                      <div className={styles.bundleDetail_cardlist}>
                        <h5>Description</h5>
                        <div
                          className={styles.htmlWrap}
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></div>
                      </div>
                    ) : (
                      <br />
                    )}
                    <AppButton
                      onClick={() => handleSave(itemId)}
                      style={{ cursor: "pointer" }}
                      disabled={error !== ""}
                      variant="contained"
                      color={
                        saveOptopnList.filter((product: any) => {
                          return (
                            product.value === "" && product.productId === itemId
                          );
                        }).length > 0
                          ? "primary"
                          : "success"
                      }
                    >
                      Save & Continue
                    </AppButton>
                    <button id={`save-${itemId}`} style={{ display: "none" }} type="button" onClick={() => {
                      save(selectedItem)
                    }}>Save</button>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </AppContainer>
    </>
  );
};

export default BundleDetailCards;
